export type MessageId =
  | `basic.g2wInitializationRequest`
  | `basic.g2wInitializationResponse`
  | `basic.g2wSoundUpdateNotification`
  | `openpage.g2wOpenPageCommand`
  | `loadingstatus.g2wLoadingStartNotification`
  | `loadingstatus.g2wLoadingProgressNotification`
  | `loadingstatus.g2wLoadingEndNotification`
  | `loadingstatus.g2wReadyNotification`
  | `autoplay.g2wAutoplayStartNotification`
  | `autoplay.g2wAutoplayEndNotification`
  | `autoplay.w2gInterruptGameplayCommand`
  | `gameround.g2wGameRoundStartNotification`
  | `gameround.g2wGameRoundEndNotification`
  | `gameplaystate.g2wGameplayStateNotification`
  | `basic.w2gInitializationRequest`
  | `basic.w2gInitializationResponse`
  | `basic.w2gSoundUpdateNotification`
  | `balancerefresh.w2gRefreshBalanceCommand`
  | `errordelegation.g2wErrorDelegationRequest`
  | `errordelegation.w2gErrorDelegationResponse`
  | `switchgame.g2wSwitchGameCommand`
  | `closegame.g2wCloseGameResponse`
  | `closegame.w2gCloseGameRequest`
  | `basic.g2wCloseGameFrameCommand`;

export enum PlaytechRecevingEvents {
  INITIALIZATION_REQUEST = 'ucip.basic.g2wInitializationRequest',
  GAME_LOAD_STARTED = 'ucip.loadingstatus.g2wLoadingStartNotification',
  GAME_LOAD_PROGRESS = 'ucip.loadingstatus.g2wLoadingProgressNotification',
  GAME_LOAD_COMPLETED = 'ucip.loadingstatus.g2wLoadingEndNotification',
  GAME_READY = 'ucip.loadingstatus.g2wGameReadyNotification',
  SOUND_UPDATE = 'ucip.sound.g2wSoundUpdateNotification',
  AUTOPLAY_START = 'ucip.autoplay.g2wAutoplayStartNotification',
  AUTOPLAY_END = 'g2wAutoplayEndNotification',
  ROUND_START = 'ucip.gameround.g2wGameRoundStartNotification',
  ROUND_END = 'ucip.gameround.g2wGameRoundEndNotification',
  GAME_STATE = 'ucip.gameplaystate.g2wGameplayStateNotification',
  ERROR_DELEGATION = 'ucip.errordelegation.g2wErrorDelegationRequest',
  SWITCH_GAME = 'ucip.switchgame.g2wSwitchGameCommand',
  CLOSE_GAME_RESPONSE = 'ucip.closegame.g2wCloseGameResponse',
  CLOSE_GAME_FRAME_COMMAND = 'ucip.basic.g2wCloseGameFrameCommand',
  OPEN_NOTIFICATION = 'ucip.gameinstance.g2wGameOpenedNotification',
  GAME_BALANCE_UPDATE_NOTIFICATION = 'ucip.balanceupdate.g2wBalanceUpdateNotification',
  GAME_CLOSE_NOTIFICATION = 'ucip.gameinstance.g2wGameCloseNotification',
}

export enum PlaytechSendingEvents {
  INITIALIZATION_RESPONSE = 'ucip.basic.w2gInitializationResponse',
  SOUND_UPDATE = 'ucip.sound.w2gSoundUpdateNotification',
  REFRESH_BALANCE = 'ucip.balancerefresh.w2gRefreshBalanceCommand',
  ERROR_DELEGATION = 'ucip.errordelegation.w2gErrorDelegationResponse',
  AUTO_SPIN_STOP = 'ucip.autoplay.w2gInterruptGameplayCommand',
  CLOSE_GAME_REQUEST = 'ucip.closegame.w2gCloseGameRequest',
}

export enum PlaytechLoggerMessages {
  NO_HANDLER = 'sendUcipMessage: Failed to get handler for provider: Playtech',
}
type UcipMessageType = `ucip.${MessageId}`;

export type PlaytechMessageUcip = {
  _type: UcipMessageType;
} & Record<string, unknown>;

export type UcipReceiveLoadingProgressInfo = PlaytechMessageUcip & {
  data: {
    _type: 'ucip.loadingstatus.g2wLoadingProgressNotification';
    progress: number;
  };
};

export type UcipReceiveSoundInfo = PlaytechMessageUcip & {
  data: {
    _type: 'ucip.basic.g2wSoundUpdateNotification';
    mute: boolean;
    level?: number;
  };
};

export type UcipReceiveSpinStatusInfo = PlaytechMessageUcip & {
  data: {
    _type:
      | 'ucip.gameround.g2wGameRoundStartNotification'
      | 'ucip.gameround.g2wGameRoundEndNotification';
  };
};

export type UcipSwitchGameInfo = PlaytechMessageUcip & {
  data: {
    _type: 'ucip.switchgame.g2wSwitchGameCommand';
    gameCode: string;
  };
};

export type UcipMessageEvent = MessageEvent<PlaytechMessageUcip>;

export type UcipHandler<T extends PlaytechMessageUcip | null> = (
  payload: T,
) => void | VoidFunction;

export type SendUcipMessage = (event: PlaytechMessageUcip) => void;

export type PlaytechCloseFrameMessage = {
  classId: number;
  reason?: string;
  widgetId?: unknown;
};

export const PLAYTECH_LIVE_GAME_STUDIOS = [
  'PLAYTECH-LIVE-GAMES',
  'PLAYTECH-FGP',
];
